export function isDesktopNavigation() {
	return window.matchMedia('only screen and (min-width: 1024px)').matches;
}
